/* eslint-disable */
export default {
  download: 'Herunterladen',
  play: 'Wiedergeben',
  pause: 'Anhalten',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"pause"@#@ @source: @#@"Pause"@#@
